<button type="button" class="upload-template-btn" (click)="fileInput.click()">Upload File</button>
<input
  #fileInput
  type="file"
  [accept]="accept"
  (change)="onFileChange($event, fileInput)"
  style="display: none"
/>
